import { FormAtylBase } from '../../form-atyl-base'

export class AtylNumber extends FormAtylBase<string> {
	controlType = 'number'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
